import { createSelector } from 'reselect';

const pendingSupplierProposalsStateSelector = (state) =>
  state.PendingSupplierProposals;

const selectById = (state, itemId) => itemId;

export const pendingSuppliersProposalsSelector = createSelector(
  [pendingSupplierProposalsStateSelector],
  (privateInquiry) => privateInquiry.items
);

export const privateInquiryByIdSelector = createSelector(
  [pendingSuppliersProposalsSelector, selectById],
  (privateInquiries, _id) => {
    const privateInquiry = privateInquiries.find((item) => _id === item._id);
    if (!privateInquiry) return null;
    return privateInquiry;
  }
);
export const pendingSuppliersPrivateInquiryAsListSelector = createSelector(
  [pendingSuppliersProposalsSelector],
  (privateInquiries) =>
    privateInquiries.map((privateInquiry) => {
      console.log(privateInquiries);
      return {
        _id: privateInquiry._id,
        message: privateInquiry.message,
        businessName: privateInquiry.customerDetail?.businessName,
        aproductName: privateInquiry.inquiry.aproductName,
      };
    })
);

export const pendingSuppliersPrivateInquiryIsLoadingSelector = createSelector(
  [pendingSupplierProposalsStateSelector],
  (privateInquiry) => privateInquiry.isLoading
);

export const pendingSuppliersPrivateInquiryCountSelector = createSelector(
  [pendingSupplierProposalsStateSelector],
  (privateInquiry) => privateInquiry.count
);

export const pendingSupplierPrivateInquiryByIdSelector = createSelector(
  [pendingSuppliersProposalsSelector, selectById],
  (suppliers, _id) => {
    const pendingSupplier = suppliers.find((item) => _id === item._id);
    console.log('found', pendingSupplier, _id);
    if (!pendingSupplier) return null;
    return pendingSupplier;
  }
);
